import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';
import _ from 'lodash';

import CONST from '../constants';
import FormSelect from '../form_select';
import BrzwDatePicker from '../../brzw_date_picker';

class FormDateTimePickerWithRecurring extends Component {
  constructor(props) {
    super(props);

    this.state = {
      frequency: props.frequency || '',
      endDate: props.endDate || '',
      showRecurring: false,
      showTime: !!props.time,
      time: props.time || props.defaultTime,
    };

    this.onChange = this.onChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.toggleTime = this.toggleTime.bind(this);
    this.onChangeFrequency = this.onChangeFrequency.bind(this);
    this.toggleRecurring = this.toggleRecurring.bind(this);
    this.onDateRecurrenceChange = this.onDateRecurrenceChange.bind(this);
  }

  onChange(datetime) {
    this.props.onChange(datetime);
  }

  onDateChange(value) {
    const { showTime } = this.state;

    const data = {
      date: null,
      time: null,
    };

    if (value) {
      data.date = value.format('YYYY-MM-DD');

      if (showTime) {
        data.time = value.format('HH:mm');
      }
    }

    this.setState(data, this.onChange(data));
  }

  onDateRecurrenceChange(value) {
    const { date, frequency, time } = this.state;
    let endDate;

    if (value) {
      endDate = value.format('YYYY-MM-DD');
    }

    this.setState(
      { endDate },
      this.onChange({
        date,
        frequency,
        endDate,
        time,
      }),
    );
  }

  onChangeFrequency(frequency) {
    const { date, time, endDate } = this.state;
    this.setState(
      { frequency },
      this.onChange({
        date,
        frequency,
        endDate,
        time,
      }),
    );
  }

  toggleRecurring() {
    this.setState({ showRecurring: !this.state.showRecurring });
  }

  toggleTime() {
    const { date, defaultTime } = this.props;
    const { showTime } = this.state;
    const newShowTime = !showTime;
    const time = showTime ? null : defaultTime;
    this.setState({ showTime: newShowTime, time }, this.onChange({ date, time }));
  }

  render() {
    const {
      className,
      classNameContainer,
      date,
      futureOnly,
      id,
      isClearable,
      label,
      required,
    } = this.props;
    const { showTime, time, frequency: frequencyState, endDate, showRecurring } = this.state;

    let selected;
    if (date) {
      if (showTime) {
        selected = moment(`${date}T${time}`);
      } else {
        selected = moment(date);
      }
    }

    let selectedRecurrance;

    if (endDate) {
      selectedRecurrance = moment(endDate);
    }

    return (
      <FormGroup row className={classnames('form-group-row -with-recurring', classNameContainer)}>
        <div className="form-group-row__label-container">
          <Label
            for={`${id}-date`}
            className="form-group-row__label form-group-row__label-with-checkbox"
          >
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
          <div className="form-group-row__checkboxes">
            <div className="time-picker-checkbox">
              <Input
                checked={showTime}
                id={`${id}-checkbox-time`}
                onChange={this.toggleTime}
                type="checkbox"
              />
              <Label
                for={`${id}-checkbox-all`}
                className="form-group-row__label form-group-row__visible-label"
              >
                Add Time
              </Label>
            </div>
            <div className="time-picker-checkbox">
              <Input
                checked={showRecurring}
                id={`${id}-checkbox-recurring`}
                onChange={this.toggleRecurring}
                type="checkbox"
              />
              <Label
                for={`${id}-checkbox-recurring`}
                className="form-group-row__label form-group-row__visible-label"
              >
                Repeat
              </Label>
            </div>
          </div>
        </div>

        <Col className="form-group-row__col">
          <BrzwDatePicker
            futureOnly={futureOnly}
            inputClassName={classnames(className, 'form-control form-group-row__input')}
            isClearable={isClearable}
            onChange={this.onDateChange}
            selected={selected}
            showTimeSelect={showTime}
          />
        </Col>

        {showRecurring && (
          <Fragment>
            <Col className="form-group-row__col mt-4">
              <FormSelect
                autoBlur
                label="Repeating"
                onChange={this.onChangeFrequency}
                options={_.map(CONST.FREQUENCY_OPTIONS, frequency => ({
                  value: frequency.value,
                  label: frequency.label,
                }))}
                placeholder="Add Frequency"
                value={frequencyState}
              />
            </Col>
            <Col className="form-group-row__col">
              <div className="form-group-row__label-container">
                <label className="form-group-row__label ">Stop Repeating on</label>
              </div>
              <BrzwDatePicker
                dateFormat="MMM D, YYYY"
                futureOnly={futureOnly}
                inputClassName={classnames('form-control form-group-row__input')}
                isClearable={isClearable}
                onChange={this.onDateRecurrenceChange}
                selected={selectedRecurrance}
              />
            </Col>
          </Fragment>
        )}
      </FormGroup>
    );
  }
}

FormDateTimePickerWithRecurring.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  date: PropTypes.string,
  defaultTime: PropTypes.string,
  frequency: PropTypes.string,
  futureOnly: PropTypes.bool,
  id: PropTypes.string,
  isClearable: PropTypes.bool,
  label: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  time: PropTypes.string,
};

FormDateTimePickerWithRecurring.defaultProps = {
  defaultTime: CONST.DEFAULT_TIME,
  futureOnly: false,
  isClearable: false,
  required: false,
};

export default FormDateTimePickerWithRecurring;
